import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsSelfExcludedInfoWidget" */ './SportsSelfExcludedInfoWidget'),
  modules: ['./SportsSelfExcludedInfoWidget'],
  loading: () => <div />
});

export default LoadableWidget;
